module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ae4fdf588b063e05cd99593e785dd60d.jpg";